import queryString from 'qs';
import { PLATFORM } from '@/constants';

export const getQuery = () => {
  const search = window.location.search.split('?')[1];
  return queryString.parse(search);
};

export const confirmPlatfrom = () => {
  const query = getQuery();
  if (!query.origin) {
    return PLATFORM.WEB.key;
  }
  return query.origin === PLATFORM.ANDROID.key ? PLATFORM.ANDROID.key : PLATFORM.IOS.key;
};
